export const tpriceData = (data) => {
  return {
    type: "TPRICE",
    payload: data,
  };
};
export const garmentData = (data) => {
  return {
    type: "GARMENT",
    payload: data,
  };
};
export const langData = (data) => {
  return {
    type: "LANGUAGE",
    payload: data,
  };
};
export const productData = (data) => {
  return {
    type: "PRODUCT",
    payload: data,
  };
};
export const campaignData = (data) => {
  return {
    type: "CAMPAIGN",
    payload: data,
  };
};
export const customerProdData = (data) => {
  return {
    type: "PRODUCT",
    payload: data,
  };
};
export const draftId = (data) => {
  return {
    type: "DRAFTID",
    payload: data,
  };
};
export const login = (data) => {
  return {
    type: "LOGIN",
    payload: data,
  };
};
